import AssessmentPackagesManagementContainer from './AssessmentPackagesManagementContainer'
export default AssessmentPackagesManagementContainer
